import { useEffect, useState } from "react";
import useFirestore from "shared/hooks/useFirestore";
import useGetBranchId from "shared/hooks/useGetBranchId";

interface lesson{
    name:string,
    teacher:string,
    days:string,
    time:string,
    etc:string
}

const useLessonInfo = (lesson_id:string) => {
    const {getBranchId} = useGetBranchId();
    const {readFirestoreOneDoc} = useFirestore();
    const [lesson, setLesson] = useState<lesson>({
        name:"",
        teacher:"",
        days:"",
        time:"",
        etc:""
    })

    useEffect(() => {
        if(lesson_id){
            getData();
        }
    }, [lesson_id])

    const getData = async() => {
        const branch_id = await getBranchId();
        const lesson = await readFirestoreOneDoc(`Lesson/Branch/${branch_id}`, lesson_id).then(res => {
            if(res.exists()){
                return res.data();
            }
            return {};
        })
        const teacher = await readFirestoreOneDoc("User/Auth/Teacher", lesson.teacher).then(res => {
            if(res.exists()){
                return res.data();
            }
            return {};
        })
        let days = "";
        lesson.days.forEach((data:string) => {
            days += data + " ";
        })
        setLesson({
            name:lesson.name,
            teacher:teacher.name,
            days:days,
            time:`${lesson.time_start} ~ ${lesson.time_end}`,
            etc:lesson.etc
        })

    }

    const onRefreshClick = () => {
        if(lesson_id){
            getData();
        }
    }

    return {lesson, onRefreshClick};
}

export default useLessonInfo;